import { ANDROID_INVITE_URL, IOS_INVITE_URL } from '../constants/downloadLinks';

export type ClientPlatformType = 'ios' | 'android' | 'desktop';

export const detectClientPlatform = (): ClientPlatformType => {
    if (typeof window === 'undefined') return 'desktop';
    const ua = (navigator.userAgent || navigator.vendor || (window as any).opera || '').toLowerCase();

    // Check iOS first (iPhone, iPad, iPod, or iPad on iOS 13+ reporting as MacIntel with touch points)
    const isIOS = /iphone|ipad|ipod/i.test(ua) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1);
    if (isIOS) return 'ios';

    // Check Android
    const isAndroid = /android/i.test(ua);
    if (isAndroid) return 'android';

    // Mac desktop
    if (/macintosh|mac os x/i.test(ua)) return 'ios';

    return 'desktop';
};

export const getPlatformAppDownloadUrl = (platform?: ClientPlatformType): string => {
    const target = platform || detectClientPlatform();
    return target === 'android' ? ANDROID_INVITE_URL : IOS_INVITE_URL;
};

export const getPlatformAppDownloadLabel = (platform?: ClientPlatformType): string => {
    const target = platform || detectClientPlatform();
    if (target === 'android') return 'Get Clero on Google Play';
    if (target === 'ios') return 'Download Clero for iPhone';
    return 'Download Clero App';
};
